import { motion } from "framer-motion";
import { WHEN_TO_USE, TIERS } from "@/data/content";
import { SectionEyebrow } from "@/components/Marquee";

export default function WhenToUse() {
  return (
    <section id="when-to-use" className="relative py-20 md:py-28 bg-void" data-testid="when-to-use-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <SectionEyebrow testId="when-to-use-eyebrow">The Timeline</SectionEyebrow>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.8, 0, 0.2, 1] }}
          className="mt-6 font-serif text-white text-5xl sm:text-6xl md:text-7xl leading-[0.98] tracking-tight max-w-4xl"
        >
          When should you use <span className="italic gradient-text">CaarSaarthi?</span>
        </motion.h2>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {WHEN_TO_USE.map((w, i) => {
            const tier = TIERS.find((t) => t.id === w.tier);
            return (
              <motion.div
                key={w.timing}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.1 }}
                className="rounded-3xl border border-white/5 bg-surface p-7 md:p-8"
                data-testid={`when-to-use-${i}`}
              >
                <p className="text-xs uppercase tracking-[0.2em] text-silver/50">{w.timing}</p>
                <p className="mt-4 italic text-silver/80 leading-snug">{w.question}</p>
                <p className="mt-6 font-serif text-3xl" style={{ color: tier?.color || "#E8E8ED" }}>
                  → {w.tier ? tier?.name : ""}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
